const allConfig = Vue => {
  const context = require.context("./", false, /.*\.json$/)
  const results = []

  context.keys().forEach(key => {
    if (~key.indexOf("debug") && !Vue.prototype.$config.app.debug) {
      return
    }

    results.push(context(key))
  })

  return Vue._.flatten(results)
}

const allVueComponents = Vue => {
  const context = require.context("../../views/", true, /.*\.vue$/)
  const results = {}

  context.keys().forEach(key => {
    if (~key.indexOf("debug") && !Vue.prototype.$config.app.debug) {
      return
    }

    const componentName = formatName(key, Vue)

    results[componentName] = context(key)
  })

  return results
}

const formatName = (name, Vue) => {
  return Vue._.upperFirst(
    Vue._.camelCase(
      name
        .split("/")
        .pop()
        .replace(/\.\w+$/, "")
    )
  )
}

const routeMixin = Vue => {
  let configs = allConfig(Vue)
  const components = allVueComponents(Vue)

  configs.forEach(val => {
    componentMappings(Vue, val, components)
  })

  return configs
}

const componentMappings = (Vue, val, components) => {
  if (Vue._.has(val, "component")) {
    val.component = components[val.component].default
  }

  if (Vue._.has(val, "children")) {
    val.children.forEach(child => {
      componentMappings(Vue, child, components)
    })
  }
}

export default Vue => {
  return routeMixin(Vue)
}
